import { localStorage, sessionStorage } from 'dibs-browser-storage';

const CALLOUT_LIMIT = 3;

export function getSessionAndStorageData(key, type) {
    const storageData = localStorage.getItem(key);
    const sessionData = sessionStorage.getItem(key);
    const storage = {
        [type]: 0,
    };
    const session = {
        [type]: false,
    };

    if (storageData) {
        Object.assign(storage, storageData);
    }

    if (sessionData) {
        Object.assign(session, sessionData);
    }

    return { session, storage };
}

export function setSessionAndStorageData(key, payload) {
    const { session, storage } = payload;
    localStorage.setItem(key, storage);
    sessionStorage.setItem(key, session);
}

export function displayNotification(payload, type, limit = 3) {
    const { session, storage } = payload;
    if (session[type]) {
        return false;
    }
    if (storage[type] >= limit) {
        return false;
    }
    return true;
}

export function saveToStorage(key, payload) {
    const { type, turnOff } = payload;
    const { session, storage } = getSessionAndStorageData(key, type);

    storage[type]++;

    if (turnOff) {
        storage[type] = CALLOUT_LIMIT;
    }

    session[type] = true;
    setSessionAndStorageData(key, { session, storage });
}
